export const SymbolUiPopupCard = Symbol('UiPopupCard')

export interface UiPopupCardProvide {
    closePopup: () => void
}
